import { Box, Typography } from "@mui/material";
import { useTranslation } from "../../../../../hooks/useTranslation";
import { useCurrency } from "../../../../../hooks/useCurrency";

type MinMaxPriceProps = {
  minPrice: number;
  price: number;
  maxPrice: number;
  pricePercentage: number;
};

export const MinMaxPrice = (props: MinMaxPriceProps) => {
  const { minPrice, price, maxPrice, pricePercentage } = props;
  const { formatCurrency } = useCurrency();

  const { translate } = useTranslation(
    "pages.inventoryManagement.inventory.list.fields.minMaxPrice",
  );

  if (price === 0) {
    return (
      <Box alignContent="center" height="100%">
        <Typography variant="body2">{translate("noPrice")}</Typography>
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      gap={0.5}
      justifyContent="center"
      height="100%"
      flexDirection="column"
    >
      <Box display="flex" alignItems="end" gap={0.5}>
        <Typography variant="body1">{formatCurrency(price)}</Typography>
        <Typography variant="caption">({pricePercentage}%)</Typography>
      </Box>
      <Box display="flex" gap={0.5} color="white">
        <Box
          sx={{
            display: "flex",
            border: "1px solid #2E8B57",
            borderRadius: "4px",
            padding: "0 4px",
            color: "#2E8B57",
          }}
        >
          <Typography variant="caption">
            {translate("min")} {minPrice}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            border: "1px solid #2E8B57",
            borderRadius: "4px",
            padding: "0 4px",
            color: "#2E8B57",
          }}
        >
          <Typography variant="caption">
            {translate("max")} {maxPrice}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
